"use strict";
// @ts-ignore
try {
    self['workbox:google-analytics:5.1.4'] && _();
}
catch (e) { }
